document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-menu]');
  if (toggle && menu) toggle.addEventListener('click', () => menu.classList.toggle('is-open'));
});

/* PagePilot cart drawer bridge */
document.addEventListener('click', (event) => {
  const cartLink = event.target.closest('a.novi-cart');
  if (!cartLink) return;

  const drawerButton = document.querySelector(
    'pagepilot-cart-drawer-trigger button'
  );

  if (drawerButton) {
    event.preventDefault();
    drawerButton.click();
  }
});
